import React from 'react';
import _ from 'lodash';
export default function LinkFix(_ref) {
  var {
    href,
    children
  } = _ref;
  var r = new RegExp(/(?:^[a-z][a-z0-9+.-]*:|\/\/)/, 'i');
  var sanitizedChildren = _.isEmpty(children) ? children : children[0];

  if (r.test(href)) {
    // Link is external
    return /*#__PURE__*/React.createElement("a", {
      rel: "nofollow",
      href: href
    }, sanitizedChildren);
  }

  return /*#__PURE__*/React.createElement("a", {
    href: href
  }, sanitizedChildren);
}